import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { localAppStorage } from './local-storage';
import { zonoApi } from '../api/zonoApi';
import { userAuthSlice } from '../user-auth/userAuth.slice';
import { customerInviteSlice } from '../customer-invite/customer-invite.slice';
import appReducer from './AppReducer';
import { orderDataSlice } from '../order/order-slice';
import { dateStateSlice } from '../date/date-slice';
import { productSlice } from '../product/product-slice';
import { paymentSlice } from '../payment/payment-slice';
import { tourSlice } from '../tour/tour-slice';
import { conversationSlice } from '../conversations/conversations-slice';
import { fieldOpsSlice } from '../field-ops';
import { getConfigValue } from '@zonofi/common/functions/get-config-value/get-config-value';
import { tripSlice } from '../trip/trip-slice';
import { configSlice } from '../config/config.slice';
import { downloadStatusSlice, offlineQueueSlice } from '../offline';

const persistConfig = {
  key: `root-${getConfigValue('APP_ID')}`,
  storage: localAppStorage,
  whitelist: [
    userAuthSlice.name,
    customerInviteSlice.name,
    orderDataSlice.name,
    dateStateSlice.name,
    productSlice.name,
    paymentSlice.name,
    tourSlice.name,
    conversationSlice.name,
    fieldOpsSlice.name,
    tripSlice.name,
    configSlice.name,
    offlineQueueSlice.name,
    downloadStatusSlice.name,
  ],
  blacklist: [zonoApi.reducerPath],
};

const rootReducer = (state: any, action: any) => {
  if (action.type === 'userAuth/logOut') {
    const updatedState = Object.fromEntries(
      Object.entries(state)?.map(([key, val]) => {
        if (key === 'app') return [key, val];
        else return [key, undefined];
      })
    );
    return appReducer(updatedState, action);
  }
  return appReducer(state, action);
};

const pReducer = persistReducer(persistConfig, rootReducer);

const reduxStore = configureStore({
  reducer: pReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat([zonoApi.middleware]),
});

export const store = reduxStore;
export const persistor = persistStore(reduxStore);
export const dispatch = reduxStore?.dispatch;
